import React from "react";
import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import request from "../../../utilities/requests";
import { toast } from "../../../utilities/SnackBarUtils";

export const gateNeeded = (config) => !!config?.terms && !config?.termsAccepted;

const ChatGate = ({ open, eventId, config, onDone, onCancel }) => {
  const { t } = useTranslation();
  const [agreed, setAgreed] = React.useState(false);
  const [busy, setBusy] = React.useState(false);

  React.useEffect(() => {
    if (!open) {
      setAgreed(false);
      return;
    }
    if (!gateNeeded(config)) onDone({ termsAccepted: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const acceptTerms = async () => {
    setBusy(true);
    const result = await request("eventchat/terms", "post", { eventId });
    setBusy(false);
    if (!result?.success) {
      toast.error(result?.error || t("chat.error.generic"));
      return;
    }
    onDone({ termsAccepted: true });
  };

  return (
    <Dialog
      open={open && gateNeeded(config)}
      onClose={onCancel}
      fullWidth
      maxWidth="xs"
      PaperProps={{ sx: { borderRadius: "24px" } }}
    >
      <DialogTitle>{t("chat.terms.title")}</DialogTitle>
      <DialogContent>
        <Typography
          sx={{ fontSize: 14, lineHeight: 1.6, whiteSpace: "pre-wrap", mb: 2 }}
        >
          {config?.terms}
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
            />
          }
          label={t("chat.terms.agree")}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          className="tnfm-pill-btn"
          style={{ minHeight: 32, paddingLeft: 16, paddingRight: 16 }}
          onClick={onCancel}
          disabled={busy}
        >
          {t("chat.cancel")}
        </Button>
        <Button
          className="tnfm-pill-btn"
          style={{ minHeight: 32, paddingLeft: 24, paddingRight: 24 }}
          variant="contained"
          disabled={!agreed || busy}
          onClick={acceptTerms}
        >
          {busy ? <CircularProgress size={20} /> : t("chat.terms.continue")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChatGate;
